const luhnChk = function(ccNum) {
  const arr = [0, 2, 4, 6, 8, 1, 3, 5, 7, 9];
  let len = ccNum.length, bit = 1, sum = 0, val;
  while (len) {
    val = parseInt(ccNum.charAt(--len), 10);
    sum += (bit ^= 1) ? arr[val] : val;
  }
  return !!(sum && sum % 10 === 0);
};
const israelVatIdValidator = (value) => {
  if (!/^[0-9]{5,9}$/.test(value?.id)) {
    return false;
  }
  const padded = value?.id?.padStart(9, "0");
  if (!luhnChk(padded)) {
    return false;
  }
  return true;
};
export {
  israelVatIdValidator
};
//# sourceMappingURL=israel-vat-id-validator.js.map
